import Portal from "../../lib/customHooks/usePortal";
import { useSelector, useDispatch } from 'react-redux';
import { updatePreviewEntry } from "../../store/actions/client";
import { ScreenPreview } from "./";
import { clientEntriesSelector } from "../../store/selectors/clientEntries";
import { ignoreConditionsSelector, disableRequiredSelector } from "../../store/selectors/clientSettings";
import { isTrueStringMatch } from "../../lib/utils";
import { applyValidations } from "../../lib/fields";
import { conditionsSelector } from "../../store/selectors/entities/conditions";
import { conditionCheck } from "../../lib/conditions";
import { useEffect, useState, useRef } from 'react';
export const TableScreenModal = ({
  rowGuid: activeRowGuid,
  isNewRow = false,
  keyField,
  allowDuplicates = false,
  deleteRow = () => {},
  closeModal = () => {}
}) => {
  const dispatch = useDispatch();
  const previewEntries = useSelector(clientEntriesSelector);
  const conditions = useSelector(conditionsSelector);
  const ignoreConditions = useSelector(ignoreConditionsSelector);
  const disableRequired = useSelector(disableRequiredSelector);
  const [modalFieldState] = useState(() => [...previewEntries.filter(e => e.rowGuid === activeRowGuid)]);
  const modalSection = useRef();

  // returns an array of currently selected options for the keyfield when allow_duplicates is set to false for the screen
  // this is used to prevent duplicate options being selected when the keyfield is a dropdown and contains reference data
  const currentlySelectedOptions = !allowDuplicates ? previewEntries.reduce((values, {
    id,
    rowGuid,
    value
  }) => {
    if (isTrueStringMatch(id, keyField.id) && rowGuid && value) {
      values.push(value);
    }
    return values;
  }, []) : [];
  useEffect(() => {
    const keyFieldDiv = modalSection.current.querySelector('.section--entries .preview--field:first-child input, .section--entries .preview--field:first-child select');
    if (keyFieldDiv) {
      keyFieldDiv.focus();
    }
  }, []);
  const tablePreviewValues = previewEntries.reduce((entries, entry) => {
    const {
      guid,
      rowGuid
    } = entry;
    if (activeRowGuid === rowGuid) {
      entries.push({
        ...applyValidations(entry, {
          disableRequired
        }),
        conditionMet: ignoreConditions ? true : conditionCheck(guid, previewEntries, conditions),
        ...(entry.id === keyField.id && {
          removeDuplicates: !allowDuplicates,
          currentlySelectedOptions
        })
      });
    }
    return entries;
  }, []);

  // restores the field states of the row to the values as
  // they were before the modal was opened
  const revertEntries = () => {
    modalFieldState.forEach(({
      guid,
      value
    }) => {
      dispatch(updatePreviewEntry({
        guid,
        value
      }));
    });
    closeModal();
  };
  const anyTouched = tablePreviewValues.find(({
    touched
  }) => touched);
  const anyInvalid = tablePreviewValues.find(({
    isValid
  }) => !isValid);
  const isSaveable = !anyInvalid;
  const cancelAction = () => {
    if (isNewRow) {
      deleteRow();
    } else {
      revertEntries();
    }
    closeModal();
  };

  // use this to remove empty rows
  // const softCancelAction = () => {
  //   if (!anyTouched) {
  //     deleteRow()
  //   }
  //   closeModal()
  // }

  const modalTitle = isNewRow ? `Add Item` : `Edit Item`;
  return <Portal className="portal-modal table-screen--modal">
      <div className="portal-modal--background" />
      <div className="portal-modal--modal-content">
        <div className="portal-modal--ui-container" ref={modalSection}>
          <div className="portal-modal--scrollable">
            <div className="portal-modal--intro">
              <h2 className="portal-modal--heading">{modalTitle}</h2>
            </div>
            <ScreenPreview entries={tablePreviewValues} />
          </div>
          <div className="portal-modal--controls">
            <hr />
            <button className="foundry--button btn--link" onClick={cancelAction}>
              Cancel
            </button>
            <button className={`foundry--button button--contained ${isSaveable ? `button--active` : `button--disabled`}`} disabled={!isSaveable} onClick={closeModal}>
              Save
            </button>
          </div>
        </div>
      </div>
    </Portal>;
};